import React, { memo } from 'react';

const ApprovedCellRendererComponent = ({ data }) => {
  if (!data) return <span />;

  const { approved } = data;
  const content = approved ? (
    <i className="text-success fa fa-check" />
  ) : approved === false ? (
    <i className="text-danger fa fa-times" />
  ) : null;

  return <div className="approvedWrapper">{content}</div>;
};

export const ApprovedCellRenderer = memo(ApprovedCellRendererComponent);
